import React from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Typography from '@material-ui/core/Typography'
import { useTranslation } from 'react-i18next'
import { UDV_SURFACE, udvDialogProps } from './udvSurface'

/**
 * @param {{
 *   open: boolean,
 *   onAck: () => void,
 *   sensitiveAction?: boolean,
 * }} props
 */
function PortalDisclaimerDlg({ open, onAck, sensitiveAction = false }) {
  const { t } = useTranslation()

  return (
    <Dialog
      open={!!open}
      onClose={() => {}}
      disableBackdropClick
      disableEscapeKeyDown
      fullWidth
      maxWidth="xs"
      {...udvDialogProps}
      role="alertdialog"
      aria-labelledby="udv-portal-disclaimer-title"
      aria-describedby="udv-portal-disclaimer-body"
    >
      <DialogTitle id="udv-portal-disclaimer-title" style={UDV_SURFACE.title}>
        {t('portal.disclaimerTitle')}
      </DialogTitle>
      <DialogContent style={UDV_SURFACE.content}>
        {sensitiveAction ? (
          <Typography
            variant="caption"
            display="block"
            style={{ ...UDV_SURFACE.muted, marginBottom: 10 }}
          >
            {t('portal.disclaimerSensitiveLead')}
          </Typography>
        ) : null}
        <Typography id="udv-portal-disclaimer-body" variant="body2" style={{ color: 'inherit' }}>
          {t('portal.disclaimerBody')}
        </Typography>
      </DialogContent>
      <DialogActions style={UDV_SURFACE.actions}>
        <Button
          color="primary"
          variant="contained"
          onClick={() => onAck && onAck()}
          style={UDV_SURFACE.btnPrimary}
          autoFocus
        >
          {t('portal.disclaimerAck')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default PortalDisclaimerDlg
